'use strict';

import React, { Component } from 'react';
import    Chart from './generic.jsx'; //Sert à utiliser Highchart de manière Généric


class HighChartElement extends Component{

    render() {
        console.log('[INFO], HighChartElement, '+this.props.container);
        console.log(this.props.options)
        return (
            <div style={this.props.StyleMenu}>
                <Chart container={this.props.container} options={this.props.options}/>
                </div>
        );
    }
};

class CurveChartHighchart extends Component{
    shouldComponentUpdate(nextProps, nextState) {
        // called to ask whether the component should be updated
        console.log("[INFO], barchart billl ;; shouldComponentUpdate ######################");
        return true;
    }
    componentWillReceiveProps() {
        // called after the props are updated
        var seriesVal = this.props.series;
        console.log("[INFO, BAR CHART BILL, componentWillReceiveProps]");
        console.log(seriesVal);
    }
    render() {
        var chartOptions = {
            chart: {
                type: 'spline',
                zoomType: 'x'
            },
            title: {
                text: this.props.title
            },
            subtitle: {
                text: ''
            },
            credits: {
                enabled: false
            },
            xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: { // don't display the dummy year
                    month: '%e. %b',
                    year: '%b'
                },
                title: {
                    text: 'Date'
                }
            },
            yAxis: [
                { // Primary yAxis
                    labels: {
                        format: '{value} W',
                        style: {
                            color: 'green'
                        }
                    },
                    title: {
                        text: 'Watt',
                        style: {
                            color: 'green'
                        }
                    },
                    opposite: true

                }, { // Secondary yAxis
                    gridLineWidth: 0,
                    title: {
                        text: 'Voltage',
                        style: {
                            color: 'blue'
                        }
                    },
                    labels: {
                        format: '{value} V',
                        style: {
                            color: 'blue'
                        }
                    }

                }, { // Tertiary yAxis
                    gridLineWidth: 0,
                    title: {
                        text: 'kWh',
                        style: {
                            color: 'orange'
                        }
                    },
                    labels: {
                        format: '{value} kWh',
                        style: {
                            color: 'orange'
                        }
                    },
                    opposite: true
                  }, { // Tertiary yAxis
                      gridLineWidth: 0,
                      title: {
                          text: 'Amp',
                          style: {
                              color: 'black'
                          }
                      },
                      labels: {
                          format: '{value} A',
                          style: {
                              color: 'black'
                          }
                      },
                      opposite: false
                }
            ],
            tooltip: {
                shared: true
            },

            plotOptions: {
                spline: {
                    marker: {
                        enabled: true
                    }
                }
            },
            series: this.props.series

        };

        var StyleMenu = {
            width: "90%",
            height: "50% ",
            margin: "0 auto",
            position: "relative"
        };
        console.log('[INFO], render bar chart,', this.props.series)
        return (<HighChartElement StyleMenu={StyleMenu} options={chartOptions} container={this.props.container}/>);
    }
};
export default CurveChartHighchart

//module.exports = CurveChartHighchart;
